export type AppGroupId = "daily" | "discover" | "operate";

export interface AppCatalogEntry {
  id: string;
  name: string;
  description: string;
  href: string;
  /** Public, state-free endpoint used to wake a scale-to-zero backend. */
  warmHref?: string;
  brand: BrandId | null;
  icon?: string;
  group: AppGroupId;
  external: boolean;
}

export interface AppCatalogGroup {
  id: AppGroupId;
  label: string;
  apps: AppCatalogEntry[];
}

/**
 * V1 catalog source. Components consume AppCatalogGroup rather than this
 * array directly so a Dashboard-backed registry can replace it later.
 */
export const appCatalog: AppCatalogEntry[] = [
  { id: "wallet", brand: "wallet", name: "Wallet Portal", description: "Cards and benefits", href: "https://wallet.mattfinkel.com", warmHref: "https://wallet.mattfinkel.com/api/health", group: "daily", external: true },
  { id: "todo", brand: "todo", name: "Todo", description: "Tasks and reminders", href: "https://todo.mattfinkel.com", warmHref: "https://todo.mattfinkel.com/api/config", group: "daily", external: true },
  { id: "tid", brand: "tid", name: "Today I Did", description: "Daily wins and lessons", href: "https://tid.mattfinkel.com", warmHref: "https://tid.mattfinkel.com/api/config", group: "daily", external: true },
  { id: "fitness", brand: "fitness", name: "Fitness Tracker", description: "Training and recovery", href: "https://fitness.mattfinkel.com", warmHref: "https://fitness.mattfinkel.com/api/healthz", group: "daily", external: true },
  { id: "movies", brand: "movies", name: "AMC Movies", description: "Showtimes worth seeing", href: "https://movies.mattfinkel.com", warmHref: "https://movies.mattfinkel.com/api/health", group: "discover", external: true },
  { id: "shows", brand: "shows", name: "Shows Attended", description: "Concert archive", href: "https://shows.mattfinkel.com", warmHref: "https://shows.mattfinkel.com/api/health", group: "discover", external: true },
  { id: "sports", brand: "sports", name: "Sports Tracker", description: "Games and schedules", href: "https://sports.mattfinkel.com", warmHref: "https://sports.mattfinkel.com/api/health", group: "discover", external: true },
  { id: "merch", brand: "merch", name: "Band Merch", description: "Merch watchlist", href: "https://merch.mattfinkel.com", warmHref: "https://merch.mattfinkel.com/api/health", group: "discover", external: true },
  { id: "dashboard", brand: "dashboard", name: "Projects Dashboard", description: "Services and repo health", href: "https://dashboard.mattfinkel.com", warmHref: "https://dashboard.mattfinkel.com/api/health", group: "operate", external: true },
  { id: "feedback", brand: null, name: "Feedback", description: "Tune recommendations", href: "/review", icon: "/app-icons/feedback.svg", group: "operate", external: false },
  { id: "sarah", brand: "sarah", name: "Sarah's Place", description: "Games and daily encouragement", href: "https://sarah.mattfinkel.com", group: "operate", external: true },
];

const groupLabels: Record<AppGroupId, string> = {
  daily: "Daily",
  discover: "Discover",
  operate: "Operate",
};

export function groupCatalog(entries: readonly AppCatalogEntry[]): AppCatalogGroup[] {
  return (Object.keys(groupLabels) as AppGroupId[]).map((id) => ({
    id,
    label: groupLabels[id],
    apps: entries.filter((entry) => entry.group === id),
  }));
}
import type { BrandId } from "@mattfinkel/common-web";
